import { render, staticRenderFns } from "./SSelectDefinition.vue?vue&type=template&id=534475b7&"
import script from "./SSelectDefinition.vue?vue&type=script&lang=js&"
export * from "./SSelectDefinition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports